import { FC, useState } from 'react';

type RenderProps = { isOpen: boolean; handleOpen: () => void; handleClose: () => void; toggle: () => void };

type ToggleProps = {
  initialIsOpen?: boolean;
  renderTrigger: ({ isOpen, handleOpen, handleClose }: RenderProps) => JSX.Element;
  renderContent: ({ isOpen, handleOpen, handleClose }: RenderProps) => JSX.Element;
  delayClose?: number;
};

const Toggle: FC<ToggleProps> = ({ initialIsOpen = false, renderTrigger, renderContent, delayClose }) => {
  const [isOn, setIsOn] = useState(initialIsOpen);

  const handleOpen = () => {
    setIsOn(true);
  };

  const handleClose = () => {
    if (delayClose) {
      setTimeout(() => setIsOn(false), delayClose);
      return;
    }
    setIsOn(false);
  };

  const toggle = () => {
    if (delayClose && isOn) {
      setTimeout(() => setIsOn(!isOn), delayClose);
      return;
    }
    setIsOn(!isOn);
  };

  return (
    <>
      {renderTrigger({ isOpen: isOn, handleOpen, handleClose, toggle })}
      {isOn && renderContent({ isOpen: isOn, handleOpen, handleClose, toggle })}
    </>
  );
};

export default Toggle;
